import { EntrepreneurAnnounce10FormInnovationContainer } from "../../../containers/SupportSystem/SupportForm/EntrepreneurAnnounce10FormInnovationContainer";
export function EntrepreneurAnnounce10FormInnovationPage() {
    return (
        <EntrepreneurAnnounce10FormInnovationContainer />
    );

}